import { useTranslations } from '@vocab/react';
import { Badge } from 'braid-design-system';
import type { FC } from 'react';

import translations from './.vocab';

type Requested = {
  status: 'requested';
};

type Available = {
  status: 'available';
  finishedCount: number;
};

export type ReferenceChecksBadgeProps = Requested | Available;

export const ReferenceChecksBadge: FC<ReferenceChecksBadgeProps> = (props) => {
  const { status } = props;

  const { t } = useTranslations(translations);

  return (
    <Badge tone={status === 'available' ? 'positive' : 'caution'}>
      {status === 'available'
        ? t('Reference/s available ({count})', { count: props.finishedCount })
        : t('Checking references')}
    </Badge>
  );
};
